import React from "react";

var WrenchScrewdriverIcon = function WrenchScrewdriverIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.232 15.354L4 16l-4 5 3 3 5-4 .646-3.232.525-.525-1.414-1.414zM20 17l3.466 3.466c.34-.753.534-1.586.534-2.466a6 6 0 0 0-6-6c-.139 0-.273.019-.409.029.079-.067.163-.125.238-.2l5-5C23.609 6.048 24 5.023 24 4s-.391-2.048-1.171-2.828a4 4 0 0 0-5.657 0l-5 5a3.965 3.965 0 0 0-.734 1.023L5.121.878C4.536.293 3.767 0 3 0S1.464.293.879.878a3 3 0 0 0 0 4.243l11.33 11.33A5.994 5.994 0 0 0 12 18a6 6 0 0 0 6 6c.88 0 1.713-.194 2.466-.534L17 20v-3zM3 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
  }));
};

WrenchScrewdriverIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
WrenchScrewdriverIcon.defaultProps.solid = true;
export default WrenchScrewdriverIcon;